import createReactComponent from '../createReactComponent';
export default createReactComponent('list', 'List', [["path",{"d":"M8 6.5h12M8 12h12M8 17.5h12M4 6.5h1M4 12h1m-1 5.5h1","key":"svg-0"}]]);